import React from 'react'
import * as Styles from './styles'
import Icon from '../icon'
import Button from '../button'
import { formatMoney } from '../../utils/format-money'

type Props = {
  'data-qa'?: string
  columns: Column[]
  rows: object[]
}

const TableCompact: React.FC<Props> = (props: Props): JSX.Element => {
  return (
    <Styles.TableContainer data-qa={props['data-qa']}>
      <Styles.Table>
        <Styles.TableHead>
          <Styles.TableRow>
            {props.columns.map((column, key) => (
              <Styles.TableCell
                key={key}
                data-qa={
                  props['data-qa'] && `${props['data-qa']}-header-cell-${key}`
                }
              >
                {column.label}
              </Styles.TableCell>
            ))}
          </Styles.TableRow>
        </Styles.TableHead>
        <Styles.TableBody>{renderRows(props)}</Styles.TableBody>
      </Styles.Table>
    </Styles.TableContainer>
  )
}

export interface Column {
  'data-qa'?: string
  id: string
  label: string
  type?:
    | 'action'
    | 'date_time'
    | 'file'
    | 'icon'
    | 'money'
    | 'number'
    | 'text'
    | 'jsx'
  width?: string | number
}

const cellOptions = (value: any): object => {
  return {
    action: <Button icon={value.icon} onClick={value.handleEvent} />,
    date_time: new Date(value)?.toLocaleDateString('pt-BR'),
    file: value.toString(),
    icon: <Icon name={value} />,
    jsx: value,
    money: formatMoney(value, 'pt-BR', 'BRL'),
    number: value.toString(),
  }
}

const renderRow = (
  props: Props,
  row: Object,
  index: number,
): React.ReactNode => (
  <Styles.TableRow
    key={index}
    data-qa={props['data-qa'] && `${props['data-qa']}-row-${index}`}
  >
    {props.columns.map((column, columnIndex) => {
      const value = row[column.id]

      return (
        <Styles.TableCell
          key={columnIndex}
          data-qa={
            props['data-qa'] &&
            `${props['data-qa']}-cell-${index}-${columnIndex}`
          }
        >
          {cellOptions(value)[column.type] || value.toString()}
        </Styles.TableCell>
      )
    })}
  </Styles.TableRow>
)

const renderRows = (props: Props): React.ReactNode =>
  props.rows.map((row: any, index: number) => renderRow(props, row, index))

export default TableCompact
